module.exports = __webpack_public_path__ + "static/media/play_has_stopped.f9f71359.png";